import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RelatorioTesourariaComponent } from './relatorio-tesouraria.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: RelatorioTesourariaComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RelatorioTesourariaRoutingModule { }
